<script setup lang="ts">
import { RouterLink, useRouter } from 'vue-router';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { ref, onMounted } from 'vue';

const auth = getAuth();
const router = useRouter();
const isLoggedIn = ref(false);
const isMenuOpen = ref(false); // NEW

onMounted(() => {
  onAuthStateChanged(auth, (user) => {
    isLoggedIn.value = !!user;
  });
});

const openNavMenu = () => {
  isMenuOpen.value = true;
};

const closeNavMenu = () => {
  isMenuOpen.value = false;
};

const logout = async () => {
  try {
    await signOut(auth);
    router.push('/login');
  } catch (error) {
    console.error("Logout failed", error);
  }
};
</script>

<template>
  <nav class="nav">
    <div class="nav-content">
      <div class="nav-logo-container">
        <img src="@/assets/images/brave_bites_new_logo.png" alt="Brave Bites Logo" />
      </div>
      <button class="open_nav_menu_button button" @click="openNavMenu">
        <font-awesome-icon :icon="['fas', 'bars']" class="fa-xl" />
      </button>
    </div>

    <!-- Overlay -->
    <div v-if="isMenuOpen" class="overlay" @click="closeNavMenu"></div>

    <!-- Slide-in menu -->
    <div :class="['side-menu', { 'open': isMenuOpen }]">
      <div class="side-menu-branding">
        <img src="@/assets/images/brave_bites_new_logo.png" />
        <p>Brave Bites</p>
      </div>
      <ul class="nav-links">
        <li>
          <router-link to="/home/" class="button back" @click="closeNavMenu">
            <font-awesome-icon class="fa-lg" :icon="['fas', 'house']" />
            <p>Home</p>
          </router-link>
        </li>
        <li>
          <router-link to="/list/" class="button back" @click="closeNavMenu">
            <font-awesome-icon class="fa-lg" :icon="['fas', 'bowl-food']" />
            <p>Dishlist</p>
          </router-link>
        </li>
        <li>
          <router-link to="/report/" class="button back" @click="closeNavMenu">
            <font-awesome-icon class="fa-lg" :icon="['fas', 'file']" />
            <p>Report</p>
          </router-link>
        </li>
        <li>
          <router-link to="/profile/" class="button back" @click="closeNavMenu">
            <font-awesome-icon class="fa-lg" :icon="['fas', 'user']" />
            <p>Profile</p>
          </router-link>
        </li>
      </ul>
      <button class="button primary logout-link" @click="logout">
        <font-awesome-icon :icon="['fas', 'right-from-bracket']" class="fa-xl" />
        <p>Logout</p>
      </button>
    </div>
  </nav>
</template>


<style scoped>
.nav {
  width: 100%;
  border-bottom: 2px solid hsl(31, 19%, 87%);
}

.nav-content {
    background-color: transparent;
    padding: 10px;
    width: 100%;
    max-width: 1200px;
    margin: auto;
    padding-left: 20px;
    display: flex;
    justify-content: space-between; /* Added to separate logo and links */
    align-items: center; /* Vertically align items */
}

.nav-logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.nav-logo-container h1 {
  font-size: 1.5rem;
  color: hsl(88, 21%, 40%);
}

.nav img {
  width: 65px;
  height: auto;
}

.nav-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  height: 45px;
  align-items: center;
  gap: 25px;
}

.nav-links li {
  height: 100%;
  width: 100%;
}

.nav-links a {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  padding: 10px;
}

.nav-links a > p {
  font-size: .8rem;
}

.logout-link {
  font-size: .8rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  position: absolute;
  bottom: 20px;
  left: 20px;
  width: 210px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 50;
}

.side-menu {
  position: fixed;
  top: 0;
  right: -300px;
  width: 250px;
  height: 100%;
  background-color: white;
  box-shadow: -2px 0 5px rgba(0,0,0,0.3);
  transition: right 0.3s ease;
  z-index: 60;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  padding: 20px;
}

.side-menu.open {
  right: 0;
}

.side-menu .nav-links {
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}

.side-menu-branding {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  margin-bottom: 30px;
}

.side-menu-branding p {
  font-weight: 600;
  color: #5aad8d;
}

.open_nav_menu_button > svg {
  color: #5aad8d;
}

</style>
